<template lang="pug">
  .unistar-process-item(
    @click="$emit('click', item)"
    :class="{active: activeSign}"
  )
    .num {{ index + 1 }}
    span {{$t(item.task_name)}}
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {
          task_name: ''
        }
      }
    },
    index: {
      type: Number
    }
  },
  computed: {
    activeSign () {
      return this.$route.fullPath.includes(this.item.action)
    }
  }
}
</script>

<style lang="stylus">
.unistar-process-item
  width 172px
  height 65px
  box-sizing border-box
  font-size 14px
  display flex
  justify-content center
  align-items center
  cursor pointer
  color #4b4f50
  background-color #fff
  .num
    width 24px
    height 24px
    border-radius 50%
    border solid 1px #3370d2
    color #3370d2
    text-align center
    line-height 24px
    margin-right 8px
.unistar-process-item.active
  border-bottom 1.5px solid #3370d2
  position relative
  font-weight 600
  .num
    color #fff
    background-color #3370d2
</style>
